import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router";
import { LanguageProvider } from "./i18n";
import { GymProvider } from "./contexts/GymContext";
import { ThemeProvider } from "./contexts/ThemeContext";
import { CurrentUserProvider } from "./contexts/CurrentUserContext";
import { installGlobalErrorHandlers, installBootWatchdog } from "./utils/crashLogger";
import { installJudgeQueueRunner } from "./utils/judgeQueue";
import { installServerTimeSync } from "./utils/serverTime";
import App from "./App";

// Catch unhandled errors/rejections outside React tree → log to Firestore
installGlobalErrorHandlers();

// Boot-stall watchdog: capture a white-screen hang (a render gate stuck on a
// full-page loader with no thrown error — see crashLogger). Durable-first, so
// the snapshot survives the dead connection that usually causes the stall and
// surfaces in the crash log on the next healthy boot.
installBootWatchdog();

// Wire up the durable judge-event queue: auto-flushes on network/visibility
// changes, drains any leftover events from a previous tab session. Must run
// before any competition route mounts so leftover writes flush ASAP.
installJudgeQueueRunner();

// Wire up server-time sync: measures the offset between Date.now() and the
// Firestore server's wall-clock so countdown beeps and end horns fire at
// the same moment on every TV / iPad / laptop watching a competition. Runs
// on auth-ready, on network online, on visibility return, and every 5 min.
installServerTimeSync();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <LanguageProvider>
        <ThemeProvider>
          <CurrentUserProvider>
            <GymProvider>
              <App />
            </GymProvider>
          </CurrentUserProvider>
        </ThemeProvider>
      </LanguageProvider>
    </BrowserRouter>
  </React.StrictMode>
);
